<!-- src/app/views/contacto/dialog-form-contacto/dialog-form-contacto.component.html -->
<div class="dialog-container">
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Contacto</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spContacto" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form" *ngIf="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <div class="delete-confirmation">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>¿Está seguro que desea eliminar el contacto <strong>{{data.item?.valorContacto}}</strong>?</p>
        <p class="delete-warning">Esta acción no se puede deshacer.</p>
      </div>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group class="form-tabs" animationDuration="300ms">

        <!-- Tab 1: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">contact_phone</mat-icon>
            Información Básica
          </ng-template>

          <div class="tab-content">
            <div class="form-section">
              <h4 class="section-title">
                <mat-icon>info</mat-icon>
                Datos del Contacto
              </h4>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spTipoContacto" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Tipo de Contacto</mat-label>
                    <mat-select placeholder="Seleccione un tipo" formControlName="TipoContacto">
                      <mat-option [value]="tipoContacto.id"
                        *ngFor="let tipoContacto of tiposContacto; let i = index; trackBy: trackByItems">
                        {{ tipoContacto.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.TipoContacto.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Valor del Contacto</mat-label>
                    <input placeholder="Ingrese el valor (email, teléfono, etc.)" type="text"
                      formControlName="ValorContacto" matInput maxlength="100" />
                    <mat-error *ngIf="f.ValorContacto.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.ValorContacto.errors?.['maxlength']">Máximo 100 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input placeholder="Descripción del contacto" type="text"
                      formControlName="Descripcion" matInput maxlength="200" />
                    <mat-error *ngIf="f.Descripcion.errors?.['maxlength']">Máximo 200 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-slide-toggle formControlName="Preferido" color="primary" class="w-100">
                    <span class="toggle-label">Contacto Preferido</span>
                  </mat-slide-toggle>
                  <p class="form-hint">Marque si es el método de contacto preferido</p>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Información Adicional -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">business</mat-icon>
            Información Adicional
          </ng-template>

          <div class="tab-content">
            <div class="form-section">
              <h4 class="section-title">
                <mat-icon>business_center</mat-icon>
                Datos Empresariales y Relación
              </h4>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Empresa Asociada</mat-label>
                    <input placeholder="Nombre de la empresa" type="text"
                      formControlName="EmpresaAsociada" matInput maxlength="100" />
                    <mat-error *ngIf="f.EmpresaAsociada.errors?.['maxlength']">Máximo 100 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de Relación</mat-label>
                    <input placeholder="Ej: Cliente, Proveedor, Socio" type="text"
                      formControlName="TipoRelacion" matInput maxlength="100" />
                    <mat-error *ngIf="f.TipoRelacion.errors?.['maxlength']">Máximo 100 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fuente del Contacto</mat-label>
                    <input placeholder="Cómo se obtuvo este contacto" type="text"
                      formControlName="FuenteContacto" matInput maxlength="100" />
                    <mat-error *ngIf="f.FuenteContacto.errors?.['maxlength']">Máximo 100 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Estado del Contacto</mat-label>
                    <input placeholder="Activo, Inactivo, Bloqueado, etc." type="text"
                      formControlName="EstadoContacto" matInput maxlength="100" />
                    <mat-error *ngIf="f.EstadoContacto.errors?.['maxlength']">Máximo 100 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Categorías/Etiquetas</mat-label>
                    <input placeholder="Etiquetas separadas por comas" type="text"
                      formControlName="CategoriasEtiquetas" matInput maxlength="200" />
                    <mat-hint>Ej: VIP, Urgente, Corporativo</mat-hint>
                    <mat-error *ngIf="f.CategoriasEtiquetas.errors?.['maxlength']">Máximo 200 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 3: Seguimiento -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">history</mat-icon>
            Seguimiento
          </ng-template>

          <div class="tab-content">
            <div class="form-section">
              <h4 class="section-title">
                <mat-icon>schedule</mat-icon>
                Información de Seguimiento
              </h4>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Último Contacto</mat-label>
                    <input matInput [matDatepicker]="pickerUltimoContacto" formControlName="FechaUltimoContacto"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerUltimoContacto"></mat-datepicker-toggle>
                    <mat-datepicker #pickerUltimoContacto></mat-datepicker>
                    <mat-hint>DD/MM/YYYY</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Preferencias de Contacto</mat-label>
                    <input placeholder="Horarios, días preferidos, etc." type="text"
                      formControlName="PreferenciasContacto" matInput maxlength="200" />
                    <mat-error *ngIf="f.PreferenciasContacto.errors?.['maxlength']">Máximo 200 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Notas de Seguimiento</mat-label>
                    <textarea placeholder="Notas sobre el seguimiento del contacto"
                      formControlName="NotasSeguimiento" matInput rows="3" maxlength="500"></textarea>
                    <mat-error *ngIf="f.NotasSeguimiento.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Historial de Interacciones</mat-label>
                    <textarea placeholder="Registro de interacciones previas"
                      formControlName="HistorialInteracciones" matInput rows="4" maxlength="1000"></textarea>
                    <mat-error *ngIf="f.HistorialInteracciones.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observaciones</mat-label>
                    <textarea placeholder="Observaciones adicionales"
                      formControlName="Observaciones" matInput rows="3" maxlength="500"></textarea>
                    <mat-error *ngIf="f.Observaciones.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </ng-template>
  </form>

</mat-dialog-content>

<!-- Vista de solo lectura -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="contacto" class="view-content">
    <mat-tab-group class="view-tabs">

      <!-- Tab 1: Información Básica -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">contact_phone</mat-icon>
          Información Básica
        </ng-template>

        <div class="tab-content">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Datos del Contacto</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Tipo de Contacto:</span>
                    <span class="property-value">{{ contacto.tipoContacto?.descripcion || 'No especificado' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Valor:</span>
                    <span class="property-value">{{ contacto.valorContacto || 'No especificado' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Preferido:</span>
                    <span class="property-value">
                      <mat-icon *ngIf="contacto.preferido" class="status-icon success">check_circle</mat-icon>
                      <mat-icon *ngIf="!contacto.preferido" class="status-icon neutral">radio_button_unchecked</mat-icon>
                      {{ contacto.preferido ? 'Sí' : 'No' }}
                    </span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Descripción:</span>
                    <span class="property-value">{{ contacto.descripcion || 'No especificada' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab 2: Información Adicional -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">business</mat-icon>
          Información Adicional
        </ng-template>

        <div class="tab-content">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Datos Empresariales</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Empresa Asociada:</span>
                    <span class="property-value">{{ contacto.empresaAsociada || 'No especificada' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Tipo de Relación:</span>
                    <span class="property-value">{{ contacto.tipoRelacion || 'No especificado' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fuente del Contacto:</span>
                    <span class="property-value">{{ contacto.fuenteContacto || 'No especificada' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Estado y Categorías</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Estado del Contacto:</span>
                    <span class="property-value">{{ contacto.estadoContacto || 'No especificado' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Categorías/Etiquetas:</span>
                    <span class="property-value">{{ contacto.categoriasEtiquetas || 'No especificadas' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab 3: Seguimiento -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">history</mat-icon>
          Seguimiento
        </ng-template>

        <div class="tab-content">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Información de Seguimiento</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Fecha Último Contacto:</span>
                    <span class="property-value">{{ contacto.fechaUltimoContacto | date:'dd/MM/yyyy' || 'No registrada' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Preferencias de Contacto:</span>
                    <span class="property-value">{{ contacto.preferenciasContacto || 'No especificadas' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Notas</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Notas de Seguimiento:</span>
                    <span class="property-value">{{ contacto.notasSeguimiento || 'Sin notas' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Observaciones:</span>
                    <span class="property-value">{{ contacto.observaciones || 'Sin observaciones' }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div class="row" *ngIf="contacto.historialInteracciones">
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="info-card">
                <mat-card-header>
                  <mat-card-title>Historial de Interacciones</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-value">{{ contacto.historialInteracciones }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form?.valid" (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar" [disabled]="!form?.valid" [isDialogClose]="true"
    (saveClicked)="modificar()" (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()"
    (cancelClicked)="closeDialog()" [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>
</div>
